(function () {
  document.querySelectorAll('[data-bundles-showcase]').forEach(function (root) {
    try {
      root.querySelectorAll('[data-bundle-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var variantId = btn.getAttribute('data-variant-id');
          if (!variantId) return;
          var originalText = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding…';

          var done = function () {
            btn.textContent = originalText;
            btn.disabled = false;
          };

          if (window.UKPSCart && window.UKPSCart.addToCart) {
            window.UKPSCart.addToCart(variantId, 1).then(done).catch(function () {
              btn.textContent = 'Try again';
              btn.disabled = false;
            });
            return;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('Add to cart failed');
              return res.json();
            })
            .then(function () {
              btn.textContent = '✓ Added';
              setTimeout(done, 1500);
            })
            .catch(function () {
              btn.textContent = 'Try again';
              btn.disabled = false;
            });
        });
      });
    } catch (e) {
      console.error('bundles-showcase: add-to-cart init failed', e);
    }

    try {
      var track = root.querySelector('[data-bundle-track]');
      var prevBtn = root.querySelector('[data-bundle-prev]');
      var nextBtn = root.querySelector('[data-bundle-next]');
      if (!track) return;

      function scrollAmount() {
        var card = track.querySelector('.bundle-card');
        var cardWidth = card ? card.getBoundingClientRect().width : 300;
        var gap = 18;
        return cardWidth + gap;
      }

      function updateArrows() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (prevBtn) prevBtn.classList.toggle('is-hidden', track.scrollLeft <= 4);
        if (nextBtn) nextBtn.classList.toggle('is-hidden', maxScroll <= 4 || track.scrollLeft >= maxScroll - 4);
      }

      function scrollByAmount(direction) {
        var amount = scrollAmount() * direction;
        if (typeof track.scrollBy === 'function') {
          try {
            track.scrollBy({ left: amount, behavior: 'smooth' });
            return;
          } catch (err) {
            /* fall through to manual scroll below */
          }
        }
        track.scrollLeft = track.scrollLeft + amount;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          scrollByAmount(-1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          scrollByAmount(1);
        });
      }

      track.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', updateArrows);
      updateArrows();
      setTimeout(updateArrows, 300);
    } catch (e) {
      console.error('bundles-showcase: carousel arrow init failed', e);
    }
  });
})();
